import React, {Component} from 'react'
import {database, auth} from 'firebase'
import './HomeScreen.css'

import TrackList from './TrackListScreen'
import SearchList from './SearchScreen'
import {
    Route,
    Switch,
    withRouter,
    Redirect,
    NavLink,
    BrowserRouter as Router
} from "react-router-dom";
import { Line } from 'react-chartjs-2'
import { connect } from "react-redux";

class HomeScreen extends Component{
    
    state={
        login: false,
        trackedItems: []
    }

    constructor(props) {
        super(props)
        auth().onAuthStateChanged(user => this.setState({login: user ? true : false}));
    }

    componentWillMount() {
        const {uid} = auth().currentUser
        database().ref(`users/${uid}`)
            .once('value', e => this.setState({ trackedItems: this.getTrackedItems(e) }))
        database().ref(`users/${uid}`)
            .on('value', e => this.setState({ trackedItems: this.getTrackedItems(e) }))
    }

    getTrackedItems = e => e.val() ? Object.keys(e.val()).map(i => e.val()[i]) : []

    getTracklist = () => <TrackList items={this.state.trackedItems} />
    getSearchList = () => <SearchList items={this.state.trackedItems} />

    render(){
        const {login,loc} = this.state
        // const path = window.location.pathname.split("/")[1]
        if (!login){
            return <div> identifying user </div>
        }
        return (
            <Router>
                <div className="HomeScreen">
                    <nav>
                        <NavLink onClick={()=>this.setState({loc:"l"})} className={loc === 'l' ? "active" : ""} to="list">TrackList</NavLink>
                        <NavLink onClick={()=>this.setState({loc:"s"})} className={loc === 's' ? "active" : ""} to="search">Search</NavLink>
                        <a onClick={() => auth().signOut()}>logout</a>
                    </nav>
                    <Line data={{
                        labels: this.props.item.map(e => e.ts ? new Date(e.ts).toLocaleTimeString('nl-NL') : 0),
                        type: 'line',
                        datasets: [{
                            label: 'buy',
                            data: this.props.item.map(e => e.buyingPrice),
                            backgroundColor:'#228B22'
                        },
                        {
                            label: 'sell',
                            data: this.props.item.map(e => e.sellingPrice),
                            backgroundColor:'#ff6384'
                        }]
                    }
                    } height={90}/>
                    {
                        login && (
                            <Switch>
                                <Route path='/list' component={this.getTracklist} />
                                <Route path='/search' component={this.getSearchList} />
                                <Redirect from='/' to='/list' />
                            </Switch>
                        )
                    }
                </div>
            </Router>
        )
    }
}

const mapStateToProps = state => {
    return {
        item: state
    };
}

export default connect(mapStateToProps)(withRouter(HomeScreen));


// WEBPACK FOOTER //
// ./src/ui/screens/HomeScreen/index.js